export default __webpack_public_path__ + "static/media/wrongIco.19517ba2.svg";